import { render, staticRenderFns } from "./ReadingTextGenerate.vue?vue&type=template&id=3a6473a7"
import script from "./ReadingTextGenerate.vue?vue&type=script&lang=js"
export * from "./ReadingTextGenerate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports